import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'wsb-atlas-button',
  templateUrl: './atlas-button.component.html',
  styleUrls: ['./atlas-button.component.scss'],
  standalone: false
})
export class AtlasButtonComponent implements OnInit {
  faCircleNotchIcon = faCircleNotch;

  @Input() public loading = false;
  @Input() public disabled = false;
  @Input() public label = '';
  @Input() public sublabel = '';
  @Input() public variant: 'primary' | 'secondary' | 'tertiary' | 'link' | 'danger' | 'primary-action' | 'icon' | 'outline-primary' =
    'primary';
  @Input() public buttonType: 'submit' | 'button' = 'button';
  @Input() public icon;
  @Input() public inlineIcon;
  @Input() public roundButton = true;
  @Input() public noHover = false;
  @Input() public size: 'sm' | 'lg' | null = null;

  @Output() btnClick = new EventEmitter<void>();
  classList = [];

  constructor() {}

  ngOnInit() {
    this.classList.push('btn-' + this.variant);
    if (!this.roundButton) {
      this.classList.push('btn--square');
    }
    if (!this.label && this.icon) {
      this.classList.push('onlyicon');
    }
    if (this.label && this.inlineIcon) {
      this.classList.push('inlineicon');
    }
    if (this.size) {
      this.classList.push(`btn-${this.size}`);
    }
    if (this.noHover) {
      this.classList.push('nohover');
    }
  }

  onClick() {
    if (!this.disabled) {
      this.btnClick.emit();
    }
  }
}
